<div class="panel-group flex-row panel-border-primary" [ngClass]="{'tw:flex-nowrap': !isMobile}">

  @if (!isMobile) {
    <div class="panel panel-left">
      <img class="ilp-sidebar-image"/>
    </div>
  }

  <div class="panel panel-right">

    <h5 class="panel-title tw:text-center font-20">
      Individual learning plan
      <span class="{{model.approved ? 'panel-title-success-status' : 'panel-title-secondary'}}">
        ( {{baselineStatus}} )
      </span>
    </h5>

    <div id="collapse1">
      <form [formGroup]="frmBaseline">

        <div class="form-group tw:text-center">
          The initial/diagnostic assessment should show the level the Learner is
          working at now, their strengths and areas for development.
        </div>

        <div class="flex-row">

          <div class="flex-column">
            <label>Date</label>
            <input type="date" class="field__control tw:w-full" required formControlName="baselineDate">
            @if (frmBaseline.controls.baselineDate.invalid && frmBaseline.controls.baselineDate.touched) {
              <span class="field__error">Date should be between {{ mindate | date : 'dd/MM/yyyy'}} and {{maxdate | date : 'dd/MM/yyyy'}}</span>
            }
          </div>

          <div class="flex-column">
            <div class="form-group">
              <label>Assessment score %</label>
              <div class="tw:flex tw:items-center">
                <input type="number" class="field__control" formControlName="assessmentScorePercentage" (keydown)="parseAssessmentScore($event)"
                  min="0" max="100" />
              </div>
              @if (frmBaseline.controls.assessmentScorePercentage.errors && (frmBaseline.controls.assessmentScorePercentage.errors.min || frmBaseline.controls.assessmentScorePercentage.errors.max)) {
                <span class="field__error">Assessment score percentage can only be between 0 and 100.</span>
              }
            </div>
          </div>

        </div>

        <div class="flex-row">

          <div class="flex-column">
            <label>Initial Key Stage</label>
            @if (! media.isActive('xs')) {
              <select class="field__control" formControlName="initialKeyStage">
                @for (stage of keyStages; track stage) {
                  <option [ngValue]="stage.id">{{stage.description}}</option>
                }
              </select>
            }
            @if (media.isActive('xs')) {
              <input class="field__control" formControlName="initialKeyStage" placeholder="Select initial key stage" type="text"
                (click)="openDropdownDialog(keyStages, 'initialKeyStage', 'Initial Key Stage', frmBaseline.value.initialKeyStage, false);"
                readonly />
            }
          </div>

          <div class="flex-column">
            <label>Initial Learning Band</label>
            @if (! media.isActive('xs')) {
              <select class="field__control" formControlName="initialLearningBand">
                @for (grade of grades; track grade) {
                  <option [ngValue]="grade.id">{{grade.code}}&nbsp;&nbsp;{{grade.description}}</option>
                }
              </select>
            }
            @if (media.isActive('xs')) {
              <input class="field__control" formControlName="initialLearningBand" placeholder="Select initial learning band"
                type="text"
                (click)="openDropdownDialog(grades, 'initialLearningBand', 'Initial Learning Band', frmBaseline.value.initialLearningBand, true);"
                readonly />
            }
            </div>

          </div>

          <div class="form-group">
            <label>Comments on initial assessment</label>
            <textarea class="field__control" #tutorInitialAssessment cdkTextareaAutosize cdkAutosizeMinRows="1"
              formControlName="tutorInitialAssessment" cdkAutosizeMaxRows="5"></textarea>
            <span class="field__hint tw:block tw:text-right">{{tutorInitialAssessment.value?.length || 0}}/1024</span>
            @if (frmBaseline.controls.tutorInitialAssessment.invalid && frmBaseline.controls.tutorInitialAssessment.touched) {
              <span class="field__error">Comments on initial assessment, characters should be between 20 and 1024</span>
            }
          </div>

          <div class="form-group">
            <label>{{themeService.siteContent.ilpBriefCommentLabel}}</label>
            <textarea class="field__control" #individualLearningPlan cdkTextareaAutosize cdkAutosizeMinRows="1"
              formControlName="individualLearningPlan" cdkAutosizeMaxRows="5"></textarea>
            <span class="field__hint tw:block tw:text-right">{{individualLearningPlan.value?.length || 0}}/1024</span>
            @if (frmBaseline.controls.individualLearningPlan.invalid && frmBaseline.controls.individualLearningPlan.touched) {
              <span class="field__error">Comments from Assignment Brief, characters should be between 20 and 1024</span>
            }
          </div>

          <div class="flex-row">
            <div class="flex-column">
              <label>Target Key Stage</label>
              @if (! media.isActive('xs')) {
                <select class="field__control" formControlName="targetKeyStage">
                  @for (stage of keyStages; track stage) {
                    <option [ngValue]="stage.id">{{stage.description}}</option>
                  }
                </select>
              }
              @if (media.isActive('xs')) {
                <input class="field__control" formControlName="targetKeyStage" placeholder="Select target key stage" type="text"
                  (click)="openDropdownDialog(keyStages, 'targetKeyStage', 'Current Key Stage', frmBaseline.value.targetKeyStage, false);"
                  readonly />
              }
            </div>
            <div class="flex-column">
              <label>Target Learning Band</label>
              @if (! media.isActive('xs')) {
                <select class="field__control" formControlName="targetLearningBand">
                  @for (grade of grades; track grade) {
                    <option [ngValue]="grade.id">{{grade.code}}&nbsp;&nbsp;{{grade.description}}</option>
                  }
                </select>
              }
              @if (media.isActive('xs')) {
                <input class="field__control" formControlName="targetLearningBand" placeholder="Select target learning band" type="text"
                  (click)="openDropdownDialog(grades, 'targetLearningBand', 'Current Learning Band', frmBaseline.value.targetLearningBand, true);"
                  readonly />
              }
              </div>
            </div>

            <div class="form-group">
              <label>Plan to achieve target</label>
              <textarea class="field__control" #targetDescription cdkTextareaAutosize cdkAutosizeMinRows="1"
                formControlName="targetDescription" cdkAutosizeMaxRows="5"></textarea>
              <span class="field__hint tw:block tw:text-right">{{targetDescription.value?.length || 0}}/1024</span>
              @if (frmBaseline.controls.targetDescription.invalid && frmBaseline.controls.targetDescription.touched) {
                <span class="field__error">Plan to achieve target, characters should be between 20 and 1024</span>
              }

            </div>

            <div class="form-group">
              <label>{{themeService.siteContent.learnerPupilLabel}} comments</label>
              <textarea class="field__control" #learnerComments cdkTextareaAutosize cdkAutosizeMinRows="1"
                formControlName="learnerComments" cdkAutosizeMaxRows="5"></textarea>
              <span class="field__hint tw:block tw:text-right">{{learnerComments.value?.length || 0}}/1024</span>
              @if (frmBaseline.controls.learnerComments.invalid && frmBaseline.controls.learnerComments.touched) {
                <span class="field__error">{{themeService.siteContent.learnerPupilLabel}} comments, should not exceed 1024 characters</span>
              }
            </div>

            @if (submissionData && submissionData.length > 0) {
              <div class="form-group">
                <div class="submission-history"><a (click)="openDialog();">View History</a></div>
              </div>
            }
            <div class="div-flex-buttons">
              <div class="div-flex-buttons">
                @if (hasStaffSavePermissions && !hasManagerSavePermissions) {
                  <div class="div-flex-buttons">
                    <div class="div-padding-right-10"><button type="submit" class="btn btn-primary" name="SaveDraft" value="Save" (click)="saveDraftbaseline()" [disabled]="model.submitted || model.approved || loading">Save</button></div>
                    <div class="div-padding-right-10"><button type="submit" class="btn btn-primary" name="Submit" value="Submit" (click)="submitBaseline()" [disabled]="model.submitted || model.approved || loading">Submit</button></div>
                    <div class="div-padding-right-10">@if (model.approved && hasUnlockPermission) {
                      <button type="submit" class="btn btn-primary" name="Unlock" value="Unlock" (click)="unlockBaseline()">Unlock</button>
                    }</div>
                  </div>
                }
                @if (hasManagerSavePermissions) {
                  <div class="div-padding-right-10 div-flex-buttons">
                    <div class="div-padding-right-10"><button type="submit" class="btn btn-primary" name="SaveDraft" value="Save" (click)="saveDraftbaseline()" [disabled]="model.approved || loading">Save</button></div>
                    <div class="div-padding-right-10"><button type="submit" class="btn btn-primary" name="Submit" value="Submit" (click)="submitBaseline()" [disabled]="model.approved || loading">Submit</button></div>
                    <div class="div-padding-right-10">@if (model.approved && hasUnlockPermission) {
                      <button type="submit" class="btn btn-primary" name="Unlock" value="Unlock" (click)="unlockBaseline()">Unlock</button>
                    }</div>
                  </div>
                }
                <div class="div-padding-right-10 div-flex-buttons">
                  @if (model.submitted && !model.approved) {
                    <report-controls (onApproved)="approveData($event)" (onRejected)="rejectData($event)"
                      [approved]="model.approved || loading" [canApprove]="hasApprovePermissions" [canReject]="hasRejectPermissions"
                    ></report-controls>
                  }
                </div>
              </div>
              <div class="div-flex-buttons tw:float-right">

                <div class="div-padding-right-10"><button type="button" class="btn btn-primary" id="RefTable" style="width: 115px;" name="RefTable" value="RefTable" (click)="openReferenceTable()">Grading Table</button></div>

                <div class="div-padding-right-10"><button type="button" class="btn btn-primary" id="Close" name="Close" value="Close" (click)="close()">Close</button></div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>